export const reduceArrayBy = (arrayToReduce: any[], prop: string) =>
  arrayToReduce.reduce(
    (acc: any, item: any) => [...acc, item[prop]] as any,
    []
  );
